import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import { selectPaymentData, selectPaymentStatus, selectPaymentError, initializeAsync } from "./paymentSlice";

import {
    getPageContent,
    updateCurrentScreen,
    updateApplicant,
    updateApplicationStatus,
    updateApplicantStatus,
    updateApplicantStatusAsync,
    updateCurrentScreenAsync,
    updateApplicantAsync,
} from "../../utils";

import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Container, Typography } from "@mui/material";

// Add custom imports here

const Payment = () => {
    const data = useSelector(selectPaymentData);
    const status = useSelector(selectPaymentStatus);
    const error = useSelector(selectPaymentError);
    const dispatch = useDispatch();

    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            updatePayment();
        }
    }, [status, dispatch]);

    const updatePayment = async () => {
        const query = new URLSearchParams(window.location.search);
        const paymentIntent = query.get("payment_intent");
        const paymentIntentClientSecret = query.get("payment_intent_client_secret");
        const redirectStatus = query.get("redirect_status");
        const amount = query.get("amount");
        const promocode = query.get("promocode");
        if (paymentIntentClientSecret) {
            let applicant = userDetails.applicant;
            applicant.paymentIntent = paymentIntent;
            applicant.paymentIntentClientSecret = paymentIntentClientSecret;
            applicant.redirectStatus = redirectStatus;
            applicant.amount = amount;
            applicant.promocode = promocode;
            await updateApplicantAsync(userDetails.applicant, "payment");
        }

        if (redirectStatus === "succeeded" || redirectStatus === "processing") {
            await updateStatusToSubmitted();
            let url = window.location.href.replace("payment", "application-completion");
            window.open(url, "_self");
        } else {
            navigate("/application/application-Payment/payment?paymentError=yes&errorcode=" + redirectStatus, {
                replace: true,
            });
        }
    };

    const updateStatusToSubmitted = async () => {
        userDetails = await updateCurrentScreenAsync(userDetails, "application-completion", ``);
        userDetails.applicant.status = "Submitted";
        setUserDetailsNotAsync(userDetails);
        await updateApplicantStatusAsync(userDetails?.applicant?.id, "Submitted");
    };

    let body = (
        <>
            <Container className="ApplicationMethod">
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress
                        color="success"
                        sx={{ width: "60px !important", height: "60px !important" }}
                        thickness="3.9"
                    />

                    <Typography variant="h6" component="div" sx={{ mt: "1rem", textAlign: "center" }}>
                        Loading payment
                    </Typography>
                    <Typography variant="h6" component="div" sx={{ mt: "1rem", textAlign: "center" }}>
                        This may take few seconds, please don't go away!
                    </Typography>
                </Box>
            </Container>
        </>
    );

    return getPageContent(body, status, error);
};

export { Payment };
